import type { CacheConfigMode } from '@cli-types/next-adapter/init.js'
import { BETTERSTART_ASSET_HOST } from '@cli-constants/scaffolding.js'
import { renderCreateNextConfigTemplateRenderer } from '@next-adapter/templates/renderers/init/scaffolders/next-config/create-next-config-template.js'

export function createNextConfigTemplate(mode: CacheConfigMode): string {
  if (mode === 'cache-components') {
    return renderCreateNextConfigTemplateRenderer({
      kind: 'renderCreateNextConfigTemplateImportsTemplate',
      props: {
        betterstartAssetHost: String(BETTERSTART_ASSET_HOST)
      }
    })
  }

  return renderCreateNextConfigTemplateRenderer({
    kind: 'renderCreateNextConfigTemplateImportsDetailsTemplate',
    props: {
      betterstartAssetHost: String(BETTERSTART_ASSET_HOST)
    }
  })
}
